import type { IValidatedResponse } from '../../../httpClient';
import { getRequest } from '../../../httpClient';
import type { IBillingListParams } from '../billing-list-params';
import { buildBillingQueryString } from '../build-billing-query-string';
import type { IListTransactionsResponse } from './list-transactions-response';
import { listTransactionsResponseSchema } from './list-transactions-response';

export async function listAdminTransactionsApi(
  params?: IBillingListParams,
): Promise<IValidatedResponse<IListTransactionsResponse>> {
  const qs = buildBillingQueryString(params);
  return getRequest<IListTransactionsResponse>({
    path: `/sys/billing/transactions${qs ? `?${qs}` : ''}`,
    schema: listTransactionsResponseSchema,
  });
}
